// Populate presets
export * from "./bot-config.populate";
export * from "./charge.populate";
export * from "./exchange-account.populate";
export * from "./payment-method.populate";
export * from "./referral.populate";
export * from "./strategy.populate";
export * from "./subscription.populate";
export * from "./user.populate";
export const TRADE_POPULATE = {
    DEFAULT: [],
};
export const NOTIFICATION_POPULATE = {
    DEFAULT: [],
};
export const WARNING_POPULATE = {
    DEFAULT: [],
};
